/* global swal, _, angular*/
import './style.less';

export default function($log, Upload, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const ngfAccept = {
    image: 'image/gif, image/png, image/jpeg, image/tiff',
    video: 'video/*',
    pdf: 'application/pdf'
  };

  vm.removeFile = () => {
    vm.action({ link: null, config: vm.actionConfig });
  };

  vm.uploadFile = file => {
    if (!file) return;
    vm.uploadBtn = true;

    let policyParams = {
      policy: vm.policyType,
      file_type: file.type,
      file_name: file.name
    };

    if (vm.policyConfig) {
      policyParams = {
        ...policyParams,
        ...vm.policyConfig
      };
    }

    ApiClass.companiesIdTypePut({ manage: true, id: ProfileClass.company_id, type: 'policies' }, policyParams)
      .then(({ data: { item: s3Policy } }) => uploadFile(file, s3Policy))
      .then(link => {
        vm.uploadBtn = false;
        vm.action({ link, config: vm.actionConfig });
        vm.preview = link;
        vm.previewStatus = true;
        delete vm.file;
      })
      .catch(error => {
        vm.uploadBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function uploadFile(file, s3Policy) {
    vm.fileProgress = 'Uploading...';
    return Upload.upload({
      url: s3Policy.filePolicy.action,
      data: s3Policy.filePolicy.fields,
      file: file,
      method: 'POST',
      skipAuthorization: true
    }).then(
      function() {
        vm.fileProgress = '';
        return s3Policy.link;
      },
      function(resp) {
        vm.action({ link: false, config: vm.actionConfig });
        vm.uploadBtn = false;
        vm.previewStatus = false;
        $log.error('Error status: ' + resp.status);
        throw new Error(`FILE UPLOADING ERROR ${resp}`);
      },
      function(evt) {
        const fileStatus = parseInt((100.0 * evt.loaded) / evt.total);
        vm.fileProgress = `Uploading: ${fileStatus}%`;
      }
    );
  }

  function activate() {
    $log.debug('Add Hour Component Activated');

    if (!vm.policyType) throw new Error('Missing policy type for file upload compoenent');
    if (!vm.action) throw new Error('Missing action for file upload compoenent');
    if (vm.fileType) vm.ngfAccept = ngfAccept[vm.fileType] || '';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/fileUpload/controller.js